export class IdGenerator {
  static generate6DigitId(): string {
    const randomNumber = Math.floor(Math.random() * 900000) + 100000;
    return randomNumber.toString();
  }

  static generateUniqueElementId = (stableId?: string): string => {
    const hasCrypto = typeof crypto !== "undefined" && typeof crypto.randomUUID === "function";

    if (stableId && hasCrypto) {
      return `${stableId}-${crypto.randomUUID()}`;
    }
    if (stableId) {
      return stableId;
    }
    if (hasCrypto) {
      return crypto.randomUUID();
    }
    return `${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
  };
}
